import React, { FC } from "react";

import { usePaymentFiltersController } from "../../../hooks/usePaymentFiltersController";
import { PaymentFiltersBase } from "./PaymentFiltersBase";

type Props = {
  controller: ReturnType<typeof usePaymentFiltersController>;
};

export const ContactPaymentsFilters: FC<Props> = ({ controller }) => {
  return (
    <PaymentFiltersBase
      showFilters={["payment-date", "label"]}
      filter={controller.filter}
      setFilter={controller.setFilter}
      filterByContact={controller.filterByContact}
      setFilterByContact={controller.setFilterByContact}
      filterByLabel={controller.filterByLabel}
      setFilterByLabel={controller.setFilterByLabel}
      labelOptions={controller.labelOptions}
    />
  );
};
